import { render } from "./KendoSpreadsheet.vue?vue&type=template&id=415c813f&scoped=true"
import script from "./KendoSpreadsheet.vue?vue&type=script&lang=js"
export * from "./KendoSpreadsheet.vue?vue&type=script&lang=js"

import "./KendoSpreadsheet.vue?vue&type=style&index=0&id=415c813f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-415c813f"]])

export default __exports__